import React from "react";
import Routes from "./Routes";
import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
